/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './post-op-recovery-record.reducer';

export const PostOPRecoveryRecord = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const postOPRecoveryRecordList = useAppSelector(state => state.postOPRecoveryRecord.entities);
  const loading = useAppSelector(state => state.postOPRecoveryRecord.loading);
  const totalItems = useAppSelector(state => state.postOPRecoveryRecord.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="post-op-recovery-record-heading" data-cy="PostOPRecoveryRecordHeading">
        <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.home.title">Post OP Recovery Records</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/post-op-recovery-record/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.home.createLabel">Create new Post OP Recovery Record</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.postOPRecoveryRecord.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {postOPRecoveryRecordList && postOPRecoveryRecordList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('time')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.time">Time</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('time')} />
                </th>
                <th className="hand" onClick={sort('painScore')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.painScore">Pain Score</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('painScore')} />
                </th>
                <th className="hand" onClick={sort('sedationScore')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.sedationScore">Sedation Score</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sedationScore')} />
                </th>
                <th className="hand" onClick={sort('intakeType')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.intakeType">Intake Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('intakeType')} />
                </th>
                <th className="hand" onClick={sort('intakeAmount')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.intakeAmount">Intake Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('intakeAmount')} />
                </th>
                <th className="hand" onClick={sort('outputType')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.outputType">Output Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('outputType')} />
                </th>
                <th className="hand" onClick={sort('outputAmount')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.outputAmount">Output Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('outputAmount')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('sedationScoreValue')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.sedationScoreValue">Sedation Score Value</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sedationScoreValue')} />
                </th>
                <th className="hand" onClick={sort('painScale')}>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.painScale">Pain Scale</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('painScale')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.surgery">Surgery</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.nurse">Nurse</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.vitals">Vitals</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.aldreteScore">Aldrete Score</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.behaviouralPainScore">Behavioural Pain Score</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.flaccScore">Flacc Score</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.nipsScore">Nips Score</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.wongBakersPainScore">Wong Bakers Pain Score</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.postOpRecovery">Post Op Recovery</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {postOPRecoveryRecordList.map((postOPRecoveryRecord, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/post-op-recovery-record/${postOPRecoveryRecord.id}`} color="link" size="sm">
                      {postOPRecoveryRecord.id}
                    </Button>
                  </td>
                  <td>{postOPRecoveryRecord.time}</td>
                  <td>{postOPRecoveryRecord.painScore}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.SedationScore.${postOPRecoveryRecord.sedationScore}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.IntakeType.${postOPRecoveryRecord.intakeType}`} />
                  </td>
                  <td>{postOPRecoveryRecord.intakeAmount}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.OutputType.${postOPRecoveryRecord.outputType}`} />
                  </td>
                  <td>{postOPRecoveryRecord.outputAmount}</td>
                  <td>{postOPRecoveryRecord.active ? 'true' : 'false'}</td>
                  <td>{postOPRecoveryRecord.cursor}</td>
                  <td>{postOPRecoveryRecord.lastupdated}</td>
                  <td>{postOPRecoveryRecord.microSec}</td>
                  <td>{postOPRecoveryRecord.timestampentry}</td>
                  <td>{postOPRecoveryRecord.sedationScoreValue}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PainScale.${postOPRecoveryRecord.painScale}`} />
                  </td>
                  <td>
                    {postOPRecoveryRecord.surgery ? (
                      <Link to={`/patient-procedure/${postOPRecoveryRecord.surgery.id}`}>{postOPRecoveryRecord.surgery.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.nurse ? (
                      <Link to={`/nurse/${postOPRecoveryRecord.nurse.id}`}>{postOPRecoveryRecord.nurse.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.vitals ? (
                      <Link to={`/vitals/${postOPRecoveryRecord.vitals.id}`}>{postOPRecoveryRecord.vitals.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.aldreteScore ? (
                      <Link to={`/aldrete-score/${postOPRecoveryRecord.aldreteScore.id}`}>{postOPRecoveryRecord.aldreteScore.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.behaviouralPainScore ? (
                      <Link to={`/behavioural-pain-score/${postOPRecoveryRecord.behaviouralPainScore.id}`}>
                        {postOPRecoveryRecord.behaviouralPainScore.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.flaccScore ? (
                      <Link to={`/flacc-score/${postOPRecoveryRecord.flaccScore.id}`}>{postOPRecoveryRecord.flaccScore.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.nipsScore ? (
                      <Link to={`/nips-score/${postOPRecoveryRecord.nipsScore.id}`}>{postOPRecoveryRecord.nipsScore.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.wongBakersPainScore ? (
                      <Link to={`/wong-bakers-pain-score/${postOPRecoveryRecord.wongBakersPainScore.id}`}>
                        {postOPRecoveryRecord.wongBakersPainScore.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {postOPRecoveryRecord.postOpRecovery ? (
                      <Link to={`/post-op-recovery/${postOPRecoveryRecord.postOpRecovery.id}`}>
                        {postOPRecoveryRecord.postOpRecovery.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/post-op-recovery-record/${postOPRecoveryRecord.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/post-op-recovery-record/${postOPRecoveryRecord.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/post-op-recovery-record/${postOPRecoveryRecord.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.postOPRecoveryRecord.home.notFound">No Post OP Recovery Records found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={postOPRecoveryRecordList && postOPRecoveryRecordList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PostOPRecoveryRecord;
